import React from "react";
import * as classes from "./submitButton.module.scss";
import classNames from "classnames";

const SubmitButton = React.forwardRef(({ tabIndex, disabled, className, children, id }, ref) => {
  const cx = classNames(className, classes.button);

  return (
    <button id={id} ref={ref} tabIndex={tabIndex} type="submit" className={cx} disabled={disabled}>
      {children}
    </button>
  );
});

export default SubmitButton;
